export type StatusCode =
  | 'A'
  | 'AC'
  | 'C'
  | 'CS'
  | 'CSL'
  | 'PS'
  | 'R'
  | 'T'
  | 'W'
  | 'X'
  | 'Q';

export enum StatusCodeEnum {
  ACTIVE = 'A',
  ACTIVE_WITH_CONTRACT = 'AC',
  CANCELLED = 'C',
  CLOSED_SALE = 'CS',
  COMING_SOON = 'CSL',
  PENDING_SALE = 'PS',
  RENTED = 'R',
  TEMP_OFF_MARKET = 'T',
  WITHDRAWN = 'W',
  EXPIRED = 'X',
  TERMINATED = 'Q',
}

export const StatusCodeGroup = {
  OFF_MARKET: [
    StatusCodeEnum.PENDING_SALE,
    StatusCodeEnum.CANCELLED,
    StatusCodeEnum.EXPIRED,
    StatusCodeEnum.TEMP_OFF_MARKET,
    StatusCodeEnum.WITHDRAWN,
    StatusCodeEnum.TERMINATED,
  ],
  ACTIVE: [StatusCodeEnum.ACTIVE, StatusCodeEnum.ACTIVE_WITH_CONTRACT],
  HAS_LISTED_PRICE: [
    StatusCodeEnum.ACTIVE,
    StatusCodeEnum.ACTIVE_WITH_CONTRACT,
    StatusCodeEnum.COMING_SOON,
    StatusCodeEnum.PENDING_SALE,
    StatusCodeEnum.TEMP_OFF_MARKET,
  ],
};

export const offMarketStatusCodes: string[] = Object.values(
  StatusCodeGroup.OFF_MARKET
);

export const hasListedPriceStatusCodes: string[] = Object.values(
  StatusCodeGroup.HAS_LISTED_PRICE
);

type TranslateType = {
  [key in StatusCode]: string;
};

export const translate: TranslateType = {
  A: 'Active',
  AC: 'Accepting Backups',
  CS: 'Sold',
  CSL: 'Coming Soon',
  R: 'Rented',
  C: 'Cancelled',
  PS: 'Under contract',
  T: 'Temp off market',
  Q: 'Terminated',
  W: 'Withdrawn',
  X: 'Expired',
};
